module.exports = __webpack_public_path__ + "img/پیچیده.eb3920c6.jpg";